import {
  ADD_DECISION_TYPE,
  ADD_DECISION_TYPE_START,
  ADD_DECISION_TYPE_ERROR,
  UPDATE_DECISION_TYPE,
  UPDATE_DECISION_TYPE_START,
  UPDATE_DECISION_TYPE_ERROR,
  GET_DECISION_TYPE,
  GET_DECISION_TYPE_START,
  GET_DECISION_TYPE_ERROR,
  GET_DECISION_TYPE_LIST,
  GET_DECISION_TYPE_LIST_PAGEABLE,
  GET_DECISION_TYPE_LIST_START,
  GET_DECISION_TYPE_LIST_ERROR,
  DELETE_DECISION_TYPE,
  DELETE_DECISION_TYPE_START,
  DELETE_DECISION_TYPE_ERROR,
  CLEAR_ERROR_DECISION_TYPE,
} from '../actions/types';

const initialState = {
  decisionTypeList: [],
  decisionType: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addDecisionTypeStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const updateDecisionTypeStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const findAllDecisionTypesStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findDecisionTypeByIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const deleteDecisionTypeStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addDecisionTypeError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateDecisionTypeError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllDecisionTypesError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findDecisionTypeByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteDecisionTypeError = (state, action) => {
  return {
    ...state,
    loading: false,
    error: action.payload,
  };
};

const addDecisionType = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionTypeList: state.decisionTypeList.concat(action.payload),
    error: undefined,
  };
};

const updateDecisionType = (state, action) => {
  return {
    ...state,

    decisionTypeList: state.decisionTypeList.map((decisionType) =>
      decisionType.id === action.payload.id ? action.payload : decisionType
    ),
    loading: false,
    error: undefined,
  };
};

const findAllDecisionTypesPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionTypeList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    error: undefined,
  };
};

const findAllDecisionTypes = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionTypeList: action.payload,
    error: undefined,
  };
};

const findDecisionTypeById = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionType: action.payload,
    error: undefined,
  };
};

const deleteDecisionType = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionTypeList: state.decisionTypeList.filter(
      (decisionType) => decisionType.id !== action.payload
    ),
    error: undefined,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_DECISION_TYPE:
      return addDecisionType(state, action);
    case ADD_DECISION_TYPE_START:
      return addDecisionTypeStart(state);
    case ADD_DECISION_TYPE_ERROR:
      return addDecisionTypeError(state, action);

    case UPDATE_DECISION_TYPE:
      return updateDecisionType(state, action);
    case UPDATE_DECISION_TYPE_START:
      return updateDecisionTypeStart(state);
    case UPDATE_DECISION_TYPE_ERROR:
      return updateDecisionTypeError(state, action);

    case GET_DECISION_TYPE:
      return findDecisionTypeById(state, action);
    case GET_DECISION_TYPE_START:
      return findDecisionTypeByIdStart(state);
    case GET_DECISION_TYPE_ERROR:
      return findDecisionTypeByIdError(state, action);

    case GET_DECISION_TYPE_LIST:
      return findAllDecisionTypes(state, action);
    case GET_DECISION_TYPE_LIST_START:
      return findAllDecisionTypesStart(state);
    case GET_DECISION_TYPE_LIST_ERROR:
      return findAllDecisionTypesError(state, action);
    case GET_DECISION_TYPE_LIST_PAGEABLE:
      return findAllDecisionTypesPageable(state, action);

    case DELETE_DECISION_TYPE:
      return deleteDecisionType(state, action);
    case DELETE_DECISION_TYPE_START:
      return deleteDecisionTypeStart(state);
    case DELETE_DECISION_TYPE_ERROR:
      return deleteDecisionTypeError(state, action);
    case CLEAR_ERROR_DECISION_TYPE:
      return clearError(state);
    default:
      return state;
  }
}
